export const productLinks = [
  {
    pathname: '/products/emissions',
    label: '<span><strong>AirQast</strong> Emissions</span>',
  },
  {
    pathname: '/products/forecast-system',
    label: '<span><strong>AirQast</strong> Forecast</span>',
  },
  {
    pathname: '/products/retina',
    label: '<span><strong>AirQast</strong> Retina</span>' },
  {
    pathname: '/products/tools',
    label: '<span><strong>AirQast</strong> ATMO-Plan</span>' },
];

export const menuLinks = [
  { pathname: '/', label: '<span>Homepage</span>', onlyMobile: true, children: null },
  { pathname: null, label: 'Products', children: productLinks },
  { pathname: '/about-us', label: '<span>About us</span>', children: null },
  { pathname: '/api', label: '<span>API</span>', children: null },
  { pathname: '/stories', label: '<span>Stories</span>', children: null },
  { pathname: '/contact-us', label: '<span>Contact</span>', children: null }
];



// WEBPACK FOOTER //
// ./src/app/main-nav/constants.js